






















import BaseMaturityBanner from './base-components/BaseMaturityBanner.vue';
import { IMaturityBanner, getFullFormattedDate } from '../../../api/index';
export default {
  name: 'MaturityBanners',
  props: {
    // This is the List of Banner from API
    apiBanners: {
      type: Array,
      default: null,
    },
    // This is the content for all available banners
    // This can come from Sitecore
    contentBanners: {
      type: Array,
      default: null,
    },
  },
  components: { BaseMaturityBanner },
  methods: {
    // Banner Data Through Type - this will use the View Models
    getBannerProductName(banner) {
      return (banner as IMaturityBanner).productName;
    },
    getBannerAccountNumber(banner) {
      return (banner as IMaturityBanner).accountNumber;
    },
    getBannerMaturityDate(banner) {
      return getFullFormattedDate((banner as IMaturityBanner).maturityDate);
    },
    getBannerMaturityValue(banner) {
      return (banner as IMaturityBanner).maturityValue.toString();
    },
    getBannerMaturityType(banner) {
      return (banner as IMaturityBanner).maturityType;
    },
    getBannerMaturityNextPayment(banner) {
      return getFullFormattedDate((banner as IMaturityBanner).nextPaymentDate);
    },

    // Loop through Static content for the Banners to get the correct content - based on the maturity Type
    getBannerContent(maturityType) {
      let contentItem = null;
      if (this.contentBanners) {
        this.contentBanners.forEach((item) => {
          if (
            item &&
            item.fields &&
            item.fields.MaturityType &&
            item.fields.MaturityType.fields &&
            item.fields.MaturityType.fields.MaturityTypeRef &&
            item.fields.MaturityType.fields.MaturityTypeRef.value &&
            maturityType === item.fields.MaturityType.fields.MaturityTypeRef.value
          ) {
            contentItem = item;
          }
        });
      }
      return contentItem;
    },
  },
};
